/**
 * Phase 5: Lightweight A/B Testing Framework for Mamapachita
 *
 * Usage: Define experiments in the MP_EXPERIMENTS array below.
 * Each experiment targets a CSS selector and applies variant styles or text.
 * Results are tracked via GA4 events.
 *
 * To add a new experiment:
 * 1. Add an object to MP_EXPERIMENTS with: id, selector, variants
 * 2. Each variant has: name, and optionally css{} or text
 * 3. The user is randomly assigned a variant (persisted via cookie for 30 days)
 * 4. Results tracked as 'ab_experiment' GA4 events
 *
 * To disable: set experiment.active = false
 */
(function () {
  'use strict';

  // ──── EXPERIMENT DEFINITIONS ────
  // Edit this array to configure experiments.
  // variant[0] is always the control (no changes applied).
  var MP_EXPERIMENTS = [
    {
      id: 'atc_color_v1',
      active: false, // Set to true to activate
      selector: '.product-form__add-button',
      variants: [
        { name: 'control' },
        { name: 'gold_bg', css: { background: '#A88340', color: '#fff', borderColor: '#A88340' } },
        { name: 'dark_bg', css: { background: '#2D2926', color: '#fff', borderColor: '#2D2926' } }
      ]
    },
    {
      id: 'trust_badges_v1',
      active: false,
      selector: '.mp-trust',
      variants: [
        { name: 'control' },
        { name: 'hidden', css: { display: 'none' } }
      ]
    }
  ];
  // ──── END EXPERIMENT DEFINITIONS ────

  // Cookie helpers
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  // Track experiment assignment
  function trackExperiment(expId, variantName) {
    if (typeof gtag === 'function') {
      gtag('event', 'ab_experiment', {
        experiment_id: expId,
        variant_name: variantName,
        page_path: window.location.pathname,
        non_interaction: true
      });
    }
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ab_experiment',
        experimentId: expId,
        variantName: variantName
      });
    }
  }

  // Run after DOM is ready
  function runExperiments() {
    MP_EXPERIMENTS.forEach(function (exp) {
      if (!exp.active) return;

      var cookieKey = 'mp_ab_' + exp.id;
      var assigned = getCookie(cookieKey);
      var variantIndex;

      if (assigned !== null) {
        variantIndex = parseInt(assigned, 10);
        if (isNaN(variantIndex) || variantIndex >= exp.variants.length) {
          variantIndex = 0;
        }
      } else {
        variantIndex = Math.floor(Math.random() * exp.variants.length);
        setCookie(cookieKey, variantIndex, 30);
        // Only track on first assignment
        trackExperiment(exp.id, exp.variants[variantIndex].name);
      }

      // Control variant (index 0) = no changes
      if (variantIndex === 0) return;

      var variant = exp.variants[variantIndex];
      var elements = document.querySelectorAll(exp.selector);

      elements.forEach(function (el) {
        if (variant.css) {
          Object.keys(variant.css).forEach(function (prop) {
            el.style[prop] = variant.css[prop];
          });
        }
        if (variant.text !== undefined) {
          el.textContent = variant.text;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runExperiments);
  } else {
    runExperiments();
  }
})();
